const allowedLetters = 'a-zA-Z0-9_@+àáâäèéêëîïíóôœùúûüñÿçÀÁÂÄÈÉÊËÎÏÍÓÔŒÙÚÛÜÑŸÇ\'\\-';
const domainPart = `[${allowedLetters}](?:[${allowedLetters}]*[${allowedLetters}])?`;
const regexString = `^[${allowedLetters}!#$%&'*+/=?^_\`{|}~]+(?:\\.[${allowedLetters}!#$%&'*+/=?^_\`{|}~]+)*@${domainPart}(?:\\.${domainPart})*$`;

export const emailRegExp = new RegExp(regexString, 'i');
